<template>
    <b-nav-text class="filter-by-day">
        <b-dropdown
            id="filter-dropdown-button"
            v-b-tooltip.hover
            variant="transparent"
            :title="$translate('filter_by_day')"
            class="filter-dropdown"
            right
        >
            <template #button-content>
                <div class="filter-icon">
                    <i class="fa fa-sliders" />
                    <span v-if="filteredDays.length" class="filter-badge">
                        {{ filteredDays.length }}
                    </span>
                </div>
            </template>

            <b-dropdown-form id="filter-dropdown-content">
                <b-form-checkbox-group @change="updateDays">
                    <b-form-checkbox
                        v-for="option in availableDays"
                        :id="`filter-dropdown-checkbox-day-${option.value}`"
                        :key="option.value"
                        v-model="selected"
                        :value="option.value"
                    >
                        <span>{{ option.day }}</span>
                        <span>{{ option.range }}</span>
                    </b-form-checkbox>
                </b-form-checkbox-group>
            </b-dropdown-form>

            <template v-if="filteredDays.length">
                <b-dropdown-divider />
                <div class="clear-filter" @click.stop="clearFilter">
                    {{ $translate('clear_filter') }}
                </div>
            </template>
        </b-dropdown>
    </b-nav-text>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Utils from '../../../business/utils/Utils'

export default {
    name: 'FilterByDay',
    data() {
        return {
            selected: []
        }
    },
    computed: {
        ...mapState({
            filteredDays: state => state.filter.filterDays
        }),
        ...mapGetters({
            maxDay: 'timelapse/getMaxDayForFilter'
        }),
        availableDays() {
            return Utils.getFilterByDayOption(this.maxDay)
        }
    },
    mounted() {
        this.selected = this.filteredDays
    },
    methods: {
        clearFilter() {
            this.selected = []
            this.updateDays()
        },
        updateDays() {
            this.$store.commit('filter/filterDays', this.selected)
        }
    }
}
</script>

<style lang="scss">
.filter-by-day {
    max-height: 100%;

    @media screen and #{$new-break3close} {
        text-align: end;
    }
    @media screen and #{$new-break4open} {
        width: 2rem;
        text-align: center;
    }

    .filter-dropdown {
        .dropdown-toggle::after {
            content: none;
        }

        .filter-icon {
            font-size: 1.4rem;
            color: $light;
            line-height: 1.3;

            .filter-badge {
                font-size: 0.75rem;
                position: absolute;
                top: 0;
                right: -0.5rem;
                width: 1rem;
                height: 1rem;
                color: #fff;
                border-radius: 50%;
                background-color: $blue;
            }
        }

        .b-dropdown-form {
            padding: 0 0 0 2.5rem;

            .custom-control-inline {
                width: 100%;
                margin: 0;
                padding: 0;

                .custom-control-label {
                    display: grid;
                    grid-template-columns: 1fr 2fr;
                    column-gap: 1rem;
                    white-space: nowrap;
                    margin-block: 0.25rem;
                    cursor: pointer;

                    &:hover {
                        background-color: $dark-5;
                    }
                }
            }
        }

        .clear-filter {
            cursor: pointer;
            width: 100%;
            padding: 0.25rem 0.25rem 0.25rem 2.5rem;

            &:hover {
                background-color: $dark-5;
            }
        }
    }
}
</style>
